import { MutationTree } from 'vuex';

import { subscribableStore } from './common';
import { WeatherState } from './types';

const mutations: MutationTree<WeatherState> = {
  ...subscribableStore.mutations,
};

export default mutations;
